// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"PhotoHeadNav_navWrapper__1LVGf","pageNavIcon":"PhotoHeadNav_pageNavIcon__1V6FZ","gridViewWrapper":"PhotoHeadNav_gridViewWrapper__1N64p"};